import { render, staticRenderFns } from "./OPENVPNHistoryForm.vue?vue&type=template&id=e22be21c&"
import script from "./OPENVPNHistoryForm.vue?vue&type=script&lang=js&"
export * from "./OPENVPNHistoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports